
// 命宫、胎元、身宫在算命术中被称之为命中“三桓(huán)”，又称之命中三柱;
// 命宫、胎元、身宫是命理预测中不可忽视的信息，尤其是盲派命理非常重视。

import { FORMAT } from "./format";
import { WUXING } from "./wuxing";

var SANHUAN = {
    /**
     * 十天干
     */
    tianGan: '甲乙丙丁戊己庚辛壬癸',
    /**
     * 十二地支
     */
    diZhi: '子丑寅卯辰巳午未申酉戌亥',
    /**
     * 农历月从正月到十二月
     * 即：寅卯辰巳午未申酉戌亥子丑
     */
    lunarYue: '寅卯辰巳午未申酉戌亥子丑',
    // 六十甲子
    jiazi: ["甲子","乙丑","丙寅","丁卯","戊辰","己巳","庚午","辛未","壬申","癸酉","甲戌","乙亥","丙子","丁丑","戊寅","己卯","庚辰","辛巳","壬午","癸未","甲申","乙酉","丙戌","丁亥","戊子","己丑","庚寅","辛卯","壬辰","癸巳","甲午","乙未","丙申","丁酉","戊戌","己亥","庚子","辛丑","壬寅","癸卯","甲辰","乙巳","丙午","丁未","戊申","己酉","庚戌","辛亥","壬子","癸丑","甲寅","乙卯","丙辰","丁巳","戊午","己未","庚申","辛酉","壬戌","癸亥"],
    /**
     * 获取命宫
     * 命宫是由命主的生月与生时来决定的。
     * 命宫地支：从子上起正月，逆查到生月。然后，从生月支上起生时，顺查到卯位，看临何地支，便是命宫的地支。
     * 命宫天干：命宫天干则看命宫地支在生月地支之前还是之后，之前从月干逆查，之后从月干顺查，查到命宫地支位，便可定出命宫的天干。
     * 口诀：若问命主何命宫，子起正月逆查行。生月支上起生时，顺查至卯知命宫。生月天干两头查，顺逆宫支天干停。
     * @param {月干} yueGan 
     * @param {月支} yueZhi 
     * @param {时支} shiZhi 
     */
    getMingGongByYueShi_bak(yueGan, yueZhi, shiZhi) {
        // console.error('getMingGongByYueShi-----', yueGan, yueZhi, shiZhi)
        // step1 逆查到生月:参考lunarYue
        var yueIndex = 12-yueZhi;
        shiZhi = shiZhi <= 1 ? parseInt('1'+shiZhi) : shiZhi-2;
        // step2 顺查到卯位，找到命宫的地支
        var offsetShi = (12-shiZhi)+2, 
            newZhi = (yueIndex+offsetShi)%12-1;
            newZhi = newZhi >= 10 ? newZhi%10 : newZhi+2;
        // console.error('yueIndex-----', shiZhi, SANHUAN.lunarYue.charAt(shiZhi), yueIndex, SANHUAN.lunarYue.charAt(yueIndex))
        // console.error('offsetShi-----', offsetShi, newZhi, SANHUAN.diZhi.charAt(newZhi))

        // step3 查命宫天干:参考diZhi
        var tempZhi = newZhi <= 1 ? parseInt('1'+newZhi) : newZhi-2;
        var newGan = newZhi < yueZhi ? ((tempZhi+12-yueZhi)%10-(10-yueGan)+10)%10 : (yueGan+(tempZhi-yueZhi)%10)%10;
        // console.error('yueZhi------', yueZhi, newZhi, newGan, SANHUAN.tianGan.charAt(newGan))

        var resultData = {
            gan: {text: FORMAT.getTianGanByIndex(newGan), xing: WUXING.getWuXingEnByIndex(WUXING.getTianGanXingByIndex(newGan))},
            zhi: {text: FORMAT.getDiZhiByIndex(newZhi), xing: WUXING.getWuXingEnByIndex(WUXING.getDiZhiXingByIndex(newZhi))}
        }
        // console.log('getMingGongByYueShi-----', newGan, newZhi, resultData);
        return resultData;
    },
    /**
     * 获取命宫:客户端算法
     * @param {月干} yueGan 
     * @param {月支} yueZhi 
     * @param {时支} shiZhi 
     */
    getMingGongByYueShi(yueGan, yueZhi, shiZhi){
        var yueZhiIndex = yueZhi <= 1 ? parseInt('1'+yueZhi)+1 : yueZhi-2+1;
        var shiZhiIndex = shiZhi <= 1 ? parseInt('1'+shiZhi)+1 : shiZhi-2+1;
        var tempZhiIndex = 26-(yueZhiIndex+shiZhiIndex);
            tempZhiIndex = tempZhiIndex > 12 ? tempZhiIndex-12 : tempZhiIndex;
        var yueZhu = SANHUAN.tianGan.charAt(yueGan)+SANHUAN.diZhi.charAt(yueZhi);
        var mingGongIndex = SANHUAN.jiazi.indexOf(yueZhu)-(yueZhiIndex-tempZhiIndex);
            mingGongIndex = mingGongIndex >= 60 ? mingGongIndex-60 : mingGongIndex;
            mingGongIndex = mingGongIndex < 0 ? mingGongIndex+60 : mingGongIndex;
        var mingGongText = SANHUAN.jiazi[mingGongIndex],
            newGan = SANHUAN.tianGan.indexOf(mingGongText.charAt(0)),
            newZhi = SANHUAN.diZhi.indexOf(mingGongText.charAt(1));
        var resultData = {
            gan: {text: mingGongText.charAt(0), xing: WUXING.getWuXingEnByIndex(WUXING.getTianGanXingByIndex(newGan))},
            zhi: {text: mingGongText.charAt(1), xing: WUXING.getWuXingEnByIndex(WUXING.getDiZhiXingByIndex(newZhi))}
        }
        // console.log('getMingGongByYueShi-----', newGan, newZhi, resultData);
        return resultData;
    },
    /**
     * 获取身宫
     * 命宫是由命主的生月与生时来决定的。
     * 命宫地支：从子上起正月，顺查到生月。然后，从生月支上起生时，逆推到酉位，看临何地支，便是命宫的地支。
     * 命宫天干：命宫天干则看命宫地支在生月地支之前还是之后，之前从月干逆查，之后从月干顺查，查到命宫地支位，便可定出命宫的天干。
     * 口诀：身宫口诀记心中，子起正月顺查行。生月支上起生时，逆推至酉知身宫。生月天干两头查，顺逆宫支天干停。
     * @param {月干} yueGan 
     * @param {月支} yueZhi 
     * @param {时支} shiZhi 
     */
    getShenGongByYueShi(yueGan, yueZhi, shiZhi) {
        // console.error('getShenGongByYueShi-----', yueGan, yueZhi, shiZhi)
        // step1 顺查到生月:参考lunarYue
        yueZhi = yueZhi <= 1 ? parseInt('1'+yueZhi) : yueZhi-2;
        var yueIndex = yueZhi-2 >= 0 ? yueZhi-2 : parseInt('1'+yueZhi);
        // step2 起生时，逆查到酉位，找到命宫的地支
        shiZhi = shiZhi <= 1 ? parseInt('1'+shiZhi) : shiZhi-2;
        var offsetShi = shiZhi >= 7 ? shiZhi-7+1 : shiZhi+12-7+1,
            newZhi = (yueIndex+offsetShi)%12-1;
            newZhi = newZhi >= 10 ? newZhi%10 : newZhi+2;
        // console.error('yueIndex-----', yueZhi, SANHUAN.lunarYue.charAt(yueZhi), yueIndex, SANHUAN.lunarYue.charAt(yueIndex))
        // console.error('offsetShi-----', shiZhi, offsetShi, newZhi, SANHUAN.diZhi.charAt(newZhi))

        // step3 查命宫天干:参考diZhi
        yueZhi = yueZhi >= 10 ? yueZhi%10 : yueZhi+2;
        var newGan = yueZhi < newZhi ? (yueGan+(newZhi-yueZhi)%10)%10 : ((yueZhi-newZhi)%10-(10-yueGan)+10)%10-1;
        // console.error('yueZhi------', yueZhi, newZhi, newGan, SANHUAN.tianGan.charAt(newGan))
        var resultData = {
            gan: {text: FORMAT.getTianGanByIndex(newGan), xing: WUXING.getWuXingEnByIndex(WUXING.getTianGanXingByIndex(newGan))},
            zhi: {text: FORMAT.getDiZhiByIndex(newZhi), xing: WUXING.getWuXingEnByIndex(WUXING.getDiZhiXingByIndex(newZhi))}
        }
        return resultData;
    },
    /**
     * 根据月干月支获取胎元
     * 其起法是：人生月后紧接着这个月的天干与生月后第三个月的地支相配，就为胎元。
     * 即出生月的天干进一位、地支进三位，此法是求怀胎十月即受孕月的干支。
     * 口诀：胎元起法记心中，生月干支要记清;月干后位胎元干，月支后三胎元支。
     * 例如：戊寅年辛酉月生人，辛后一位为壬，酉后三位为子，则胎元为壬子，其余类推。
     * @param {月干} yueGan 
     * @param {月支} yueZhi 
     */
    getTaiYuanByYueZhu(yueGan, yueZhi) {
        var newYG = (yueGan+1)%10, newYZ = (yueZhi+3)%12;
        var resultData = {
            gan: {text: FORMAT.getTianGanByIndex(newYG), xing: WUXING.getWuXingEnByIndex(WUXING.getTianGanXingByIndex(newYG))},
            zhi: {text: FORMAT.getDiZhiByIndex(newYZ), xing: WUXING.getWuXingEnByIndex(WUXING.getDiZhiXingByIndex(newYZ))}
        }
        console.log('getTaiYuanByYueZhu-----', yueGan, yueZhi, newYG, newYZ, resultData);
        return resultData;
    }
}

export {
    SANHUAN
}